<template>
	<section>
		<div class="p-2 d-flex align-items-center">
			<!-- <el-avatar
				class="mr-2"
				:src="_.get(Ambition, 'Globals.tenant.user.avatar', null)"
				:style="`background:${this.$store.getters['user/user_colour']}`"
			>
				{{ this.$store.getters["user/user_initals"] }}
			</el-avatar> -->
            <profile-image class="mr-2"></profile-image>
			<div>
				<span>{{ myself.full_name }}</span>
				<br v-if="status" />
				<small v-if="status">{{ status }}</small>
			</div>
		</div>
		<el-menu class="w-100 chat-menu d-flex align-items-center" mode="horizontal">
			<el-submenu index="1" popper-class="chat-menu-dropdown" :popper-append-to-body="false">
				<template slot="title">
					<font-awesome-icon
						class="mr-1"
						:icon="isAdmin && !showMe ? 'user-ninja' : 'user'"
						:class="{ success: activityStatus == 'Active', warning: activityStatus == 'Away' }"
					/>
					<small>{{ activityStatus }}</small>
				</template>
				<el-menu-item @click="setActivityStatus('Active')">Active</el-menu-item>
				<el-menu-item @click="setActivityStatus('Away')">Away</el-menu-item>
				<li v-if="isAdmin"><hr /></li>
				<el-menu-item v-if="isAdmin" @click="setShowMe(!showMe)">{{ showMe == true ? "Hide" : "Show" }} Me</el-menu-item>
			</el-submenu>
			<el-submenu index="2" popper-class="chat-menu-dropdown" :popper-append-to-body="false">
				<template slot="title">
					<i class="fas fa-users-cog mr-1"></i>
					<small>Groups</small>
				</template>
				<el-menu-item @click="groupsCreate.show = true">Create Group</el-menu-item>
			</el-submenu>
		</el-menu>
		<el-input
			clearable
			size="small"
			v-model="currentChatStatus"
			class="chat-status-message w-100"
			placeholder="Set your status message..."
			maxlength="50"
		>
			<el-button slot="append" @click="updateChatStatus()">update</el-button>
		</el-input>

		<el-dialog :class="`merge-dialog`" title="Create New Group" :visible.sync="groupsCreate.show" :modal="false">
			<div slot="title" :class="`d-flex justify-content-between align-items-center`">Create New Group</div>
			<div class="group-class">
				<label for="group-name" class="mr-3">Group Name</label>
				<el-checkbox v-model="groupsCreate.is_private">make private ?</el-checkbox>
				<el-input class="mb-3" name="group-name" v-model="groupsCreate.name"></el-input>

				<label for="group-admins">Group Administrators</label>
				<el-select
					v-model="groupsCreate.group_admins"
					multiple
					name="group-admins"
					collapse-tags
					value-key="id"
					:class="`w-100 mb-3`"
					placeholder="Select"
				>
					<el-option v-for="member in members" :key="member.id" :label="member.full_name" :value="member.id"></el-option>
				</el-select>

				<label for="group-members">Add Group Members</label>
				<el-select
					v-model="groupsCreate.group_members"
					multiple
					name="group-members"
					collapse-tags
					value-key="id"
					:class="`w-100`"
					placeholder="Select"
				>
					<el-option v-for="member in members" :key="member.id" :label="member.full_name" :value="member"></el-option>
				</el-select>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="groupsCreateClose()">Cancel</el-button>
				<el-button type="success" @click="createGroup()">Create</el-button>
			</span>
		</el-dialog>
	</section>
</template>

<script>
	import { mapGetters } from "vuex"
	export default {
		name: "ChatToolBox",
		components: {},
		props: {},
		data() {
			return {
				currentChatStatus: "",
				groupsCreate: {
					show: false,
					name: "",
					group_admins: [],
					group_members: [],
					is_private: false,
				},
				options: [
					{
						value: "Active",
					},
					{
						value: "Away",
					},
				],
			}
		},
		computed: {
			...mapGetters({
				token: "token",
				members: "chat/members",
				isAdmin: "chat/isAdmin",
				showMe: "chat/showMe",
				myself: "chat/myself",
				activityStatus: "chat/activityStatus",
				status: "chat/status",
			}),
		},
		watch: {},
		mounted() {
			this.groupsCreate.group_admins.push(this.myself.id)
		},
		updated() {},
		activated() {},
		methods: {
			getInitials(name) {
				return name
					.split(" ")
					.map((e) => e.charAt(0))
					.join("")
					.toUpperCase()
			},

			getColour(username, s = 30, l = 50) {
				var hash = 0
				for (var i = 0; i < username.length; i++) {
					hash = username.charCodeAt(i) + ((hash << 5) - hash)
				}

				var h = hash % 360
				return "hsl(" + h + ", " + s + "%, " + l + "%)"
			},
			async createGroup() {
				let group = this.groupsCreate
				let res = await this.$tenant
					.post(
						`/api/v2/global-messaging-groups`,
						{
							name: group.name,
							group_admins: group.group_admins,
							group_members: group.group_members.map((member) => member.id),
							is_private: group.is_private,
						}
					)
					.then((res) => {
						console.log(res)
						this.groupsCreateClose()
					})
			},
			groupsCreateClose() {
				this.groupsCreate = {
					show: false,
					name: "",
					is_private: false,
				}
			},
			updateChatStatus() {
				let option = this.currentChatStatus
				this.$tenant
					.put(
						"/api/v2/user-settings",
						{
							chat: { status: option },
						}
					)
					.then((res) => {
						this.$store.commit("chat/setStatus", option)
					})
			},
			setShowMe(option) {
				this.$tenant
					.put(
						"/api/v2/user-settings",
						{
							chat: { showMe: option },
						}
					)
					.then((res) => {
						this.$store.dispatch("chat/setShowMe", option)
						this.$bus.$emit("chat::reset::connection", true)
					})
			},
			setActivityStatus(option) {
				this.$tenant
					.put(
						"/api/v2/user-settings",
						{
							chat: { activityStatus: option },
						}
					)
					.then((res) => {
						this.$store.dispatch("chat/setActivityStatus", option)
						this.$bus.$emit("chat::reset::connection", true)
					})
			},
		},
	}
</script>

<style lang="scss">
	// @import '@assets/sass/backend/_core-variables.scss';
	.group-class {
		max-height: 50vh;
		overflow: hidden;
		overflow-y: scroll;
		text-align: left;

		&::-webkit-scrollbar {
			display: none;
		}
		-ms-overflow-style: none; /* IE and Edge */
		scrollbar-width: none; /* Firefox */
	}

	svg {
		&.warning {
			color: #e69b13;
		}
		&.success {
			color: #3fad23;
		}
	}
	.chat-menu-dropdown {
		li {
			font-size: 12px;
		}
	}
	.chat-status-message {
		border: 0 !important;
		input {
			border: 0 !important;
		}
		.el-input-group__append {
			border: 0 !important;
		}
	}
</style>
